import { render } from "./EmployeePendingPayments.vue?vue&type=template&id=6b61527f"
import script from "./EmployeePendingPayments.vue?vue&type=script&lang=js"
export * from "./EmployeePendingPayments.vue?vue&type=script&lang=js"

import "./EmployeePendingPayments.vue?vue&type=style&index=0&id=6b61527f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__